import { invokeFlutterService } from '@/utils/flutter/flutter-service';

/**
 *
 * @param {...any} args
 * @return {void}
 */
export const log = (...args) => console.log(...args); // eslint-disable-line no-console

/**
 * Service name can be modified.
 *
 * @type {string}
 */
export const serviceName = "FlutterFirebaseAnalyticsService";

/**
 * Service types.
 *
 * @type {object}
 */
export const serviceTypes = {
    logEvent: "logEvent",
    setCurrentScreen: "setCurrentScreen",
    setUserProperty: "setUserProperty",
};

/**
 *
 * @param {object} payload
 * @return {void}
 */
export function invokeService(payload) {
    return invokeFlutterService(serviceName, JSON.stringify(payload));
}

/**
 *
 * @param {string} command
 * @param {string} targetId
 * @param {object} config
 * @return {void}
 */
export function invokeGTag(command, targetId, config) {
    if (typeof window.gtag !== "function") return log("[gtag] is not a function");

    try {
        window.gtag(command, targetId, config);
    } catch(error) {
        captureException(error);
    }
}
